// src/hooks/useFirebaseUsers.js
import { useState, useEffect } from 'react';
import FirestoreService from '../assets/js/firestore_instance';
import { doc, getDoc } from "firebase/firestore";

export function useFirebaseUsers(userIds = []) {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      if (userIds.length === 0) {
        setUsers([]);
        setIsLoading(false);
        return;
      }

      try {
        const db = FirestoreService.getFirestore();
        const userPromises = userIds.map(async (userId) => {
          try {
            const userDoc = await getDoc(doc(db, "users", userId));
            if (userDoc.exists()) {
              const userData = userDoc.data();
              return {
                id: userId,
                email: userData.email || null,
                name: userData.displayName || userData.name || "Unknown User",
                phone: userData.phoneNumber || userData.phone || null,
                avatar: userData.photourl || userData.avatar || null,
              };
            }
            return { id: userId, name: "Unknown User" };
          } catch (err) {
            console.error(`Error fetching user ${userId}:`, err);
            return { id: userId, name: "Error", error: err.message };
          }
        });

        const results = await Promise.all(userPromises);
        setUsers(results);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, [userIds]); // Re-run when userIds change

  return { users, isLoading, error };
}